import { withRouter } from 'react-router';
import React from 'react';
import paginator from 'paginator';
import {
  Pagination, 
} from 'reactstrap';

import Pager from './Pager';

const PaginationWrapper = ({ meta, baseUrl = '/customers' }) => {

  const paginationInfo = new paginator(
    meta.limit,
    5
  ).build(meta.count, meta.page);

  const renderItem = page => {
    return (
      <Pager 
        baseUrl={ baseUrl }
        key={ page }
        page={ page }
        active={ meta.page === page }
      />
    );
  }

  const renderPage = () => {
    const pages = [];
    for( let i = paginationInfo.first_page; i <= paginationInfo.last_page; i++ ) {
      pages.push(i);
    }
    return pages.map(renderItem);
  }

  const createPaginations = () => {
    const pagesCount = Math.ceil(meta.count / meta.limit);
    return (
      <Pagination>
        { paginationInfo.has_previous_page && 
          <Pager baseUrl={ baseUrl }
            page={ meta.page -1 }
            disabled={ meta.page === 1 }
            prev
          /> }
        { renderPage() }
        { paginationInfo.has_next_page && 
          <Pager baseUrl={ baseUrl }
            page={ pagesCount }
            disabled={ meta.page === pagesCount }
            next
          /> }
      </Pagination>
    )
  }

  return (
    meta.count > meta.limit && createPaginations()
  );
}

export default withRouter(PaginationWrapper);



// WEBPACK FOOTER //
// ./src/views/Components/Pagination/PaginationWrapper.js